import React, { useState, createContext, useContext } from 'react';
import Sidebar from './Sidebar';
import AppHeader from './AppHeader';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

// Create context for sidebar state
export const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
};

const DashboardLayout = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const collapsedWidth = 64;
  const expandedWidth = 260;
  const sidebarWidth = isSidebarExpanded ? expandedWidth : collapsedWidth;

  return (
    <SidebarContext.Provider
      value={{ isSidebarExpanded, setIsSidebarExpanded, sidebarWidth, collapsedWidth, expandedWidth }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {/* ✅ Header fixed at top */}
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200 }}>
          <AppHeader />
        </Box>

        {/* ✅ Main content area starts below header */}
        <Box sx={{ display: 'flex', flexGrow: 1, mt: '64px' }}>
          {/* Sidebar */}
          <Box
            sx={{
              width: `${sidebarWidth}px`,
              transition: 'width 0.3s ease',
              flexShrink: 0,
              zIndex: 1100,
            }}
          >
            <Sidebar />
          </Box>

          {/* Page content */}
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: '#f3f2f5ff',
              minHeight: 'calc(100vh - 64px)',
              transition: 'margin-left 0.3s ease',
              p: 0,
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </SidebarContext.Provider>
  );
};

export default DashboardLayout;

// import React, { useState, createContext, useContext } from 'react';
// import Sidebar from './Sidebar';
// import AppHeader from './AppHeader';
// import { Box } from '@mui/material';
// import { Outlet } from 'react-router-dom';

// // Create context for sidebar state
// export const SidebarContext = createContext();

// // Hook to use sidebar context
// export const useSidebar = () => {
//   const context = useContext(SidebarContext);
//   if (!context) {
//     throw new Error('useSidebar must be used within SidebarProvider');
//   }
//   return context;
// };

// const DashboardLayout = () => {
//   const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
//   const collapsedWidth = 64;
//   const expandedWidth = 260;
//   const sidebarWidth = isSidebarExpanded ? expandedWidth : collapsedWidth;

//   return (
//     <SidebarContext.Provider value={{ isSidebarExpanded, setIsSidebarExpanded, sidebarWidth, collapsedWidth, expandedWidth }}>
//       <Box sx={{ display: 'flex' }}>
//         <Sidebar />
//         <Box 
//           sx={{ 
//             flexGrow: 1, 
//             ml: `${sidebarWidth}px`,
//             minHeight: '100vh', 
//             bgcolor: '#F5F2F2',
//             transition: 'margin-left 0.3s ease'
//           }}
//         >
//           <AppHeader />
//           <Box sx={{ mt: '64px' }}>
//             <Outlet />
//           </Box>
//         </Box>
//       </Box>
//     </SidebarContext.Provider>
//   );
// };
// export default DashboardLayout;
